<template>
    <BuilderBase :loading="datasetStore.loading">
        <template v-slot:section-title>
            <div class="content">
                <h1 class="h1">
                    <span class="steps">{{$t('common.step_1')}} 3<span class="slash">/</span>3:</span> <span class="title" >{{$t('views.dataset_checkout.title_short')}}</span>
                </h1>
            </div>
        </template>

        <template v-slot:section-content>
            <ToggleSimple :toggleable="false" :default="true" cssClass="toggle-type-2 important-title">
                <template #toggle>
                    <div class="left">
                        <div class="toggle-text" v-html="$t(datasetStore.name ? 'views.dataset_checkout.title_alt' : 'views.dataset_checkout.title', { name: datasetStore.name || null })"></div>
                        <div class="toggle-description" v-html="$t('views.dataset_checkout.description', { count: formatNumber(datasetStore.count) || 0, price_ex_vat: formatNumber(datasetStore.finalPrice || 0, '€', '', 2), price_in_vat: formatNumber((Number(datasetStore.finalPrice) * 1.21).toFixed(2) || 0, '€', '', 2)})"></div>
                        <ul class="list-icon-pos">
                            <li>{{$t('views.dataset_checkout.bullets.0')}}</li>
                            <li>{{$t('views.dataset_checkout.bullets.1')}}</li>
                            <li>{{$t('views.dataset_checkout.bullets.2')}}</li>
                        </ul>
                    </div>
                </template>

                <template #content>
                    <div class="builder-checkout-type-1">
                        <OrderForm @form_submission_successful="proceedToCheckout()" />
                    </div>
                </template>
            </ToggleSimple>
        </template>
    </BuilderBase>
</template>

<script>
    import router from '@/router';
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import { formatNumber } from '@/utils/formatting';
    import { useDatasetStore } from '@/stores/dataset';
    import OrderForm from '@/components/forms/DatasetOrderForm';
    import BuilderBase from '@/views/builder/BuilderBase';
    import ToggleSimple from '@/components/elements/misc/ToggleSimple';

    export default {
        name: 'HomeView',
        mixins: [i18nViewMixin],
        components: {
            OrderForm,
            BuilderBase,
            ToggleSimple
        },
        data() {
            return {
                seo_title: 'views.dataset_checkout.seo_title'
            };
        },
        computed: {
            datasetStore() {
                return useDatasetStore();
            }
        },
        methods: {
            formatNumber,
            proceedToCheckout() {
                if(this.datasetStore.order?.checkout_url) {
                    window.location.href = this.datasetStore.order.checkout_url;
                } else {
                    router.push({ name: 'builder' });
                }
            },
        },
        async mounted() {
            if(!this.datasetStore.query) {
                const success = await this.datasetStore.fetchDataset(true);
                if(!success || !this.datasetStore.count) {
                    this.$router.push({name: 'builder'});
                }
            }
        }
    }
</script>